<!--
  V1:
    Avatar 是基于 Jdenticon 实现的简易的 Avatar，主要功能如下，
    1. 提供默认旋转的 avatar
    2. 若不是默认旋转的 avatar，那么实现基于 hover 事件的旋转
  V2:
    增加 image 头像
-->
<template>
    <div>
        <!--注意，要让头像旋转正常，外层的 div 必须设置和 svg 图片大小相等的尺寸，通过 baseStyle 设置-->
        <div v-bind:class="{rotate_slow: isDefaultRotate, rotate_fast: rotateFastEvent, rotate_restore: rotateRestoreEvent}"
             v-bind:style="`width: ${size}px; height: ${size}px`"
             class="avatar"
             v-on:mouseover="startRotate"
             v-on:mouseleave="stopRotate"
             v-html="svg"
             v-if="hash !== null">
        </div>
        <!-- 如果 url 的值不为 null，则显示图片 -->
        <!-- 下面这个原始的 img 实现误删除！-->
        <!-- <img :src="url"
                 v-bind:class="{rotate: isDefaultRotate, rotate_fast: rotateFastEvent, rotate_restore: rotateRestoreEvent}"
                 v-bind:style="`width: ${size}px; height: ${size}px`"
                 class="avatar"
                 style="border-radius:50%; overflow:hidden; border:0.5px solid gray; cursor:pointer"
                 v-on:mouseover="startRotate"
                 v-on:mouseleave="stopRotate"
                 v-if="url !== null"
             /> -->
        <!-- style 不再以 Object 的方式传递了，以 str 的方式传递更快捷，这里的难点是 class 的传递，它是一个随着事件的变动而变动的值，想了想，还是只能以 str 的方式传递 -->
        <sy-loading-image :src="url"
            :style-str="`width: ${size}px; height: ${size}px; border-radius: 50%; overflow: hidden; border: 0.5px solid gray; cursor: pointer`"
            :class-str="classStr"
            @mouseover.native="startRotate"
            @mouseleave.native="stopRotate"
            v-if="url !== null">
            <img slot="loading"
                 class="avatar"
                 style="border-radius:50%; overflow:hidden; border:0.5px solid gray; cursor:pointer"
                 :src="require('@/assets/transparent-gray_320x320.png')" :style="`width: ${size}px; height: ${size}px`"/>
        </sy-loading-image>
    </div>
</template>

<script>
    import SyLoadingImage from "./SyLoadingImage";
    const jdenticon = require("jdenticon");
    var util = require('util');
    export default {
        name: "Avatar",
        components: {SyLoadingImage},
        props: {
            // 目前使用 Jdenticon 来实现头像，Jdenticon 需要一个 hash 值来填充 SVG，可以是任意的 String 字符串。
            hash: {
                type: String,
                default: null
            },
            url: {
                type: String,
                default: null
            },
            size: Number,
            // 是否默认 rotate
            isDefaultRotate: {
                type: Boolean,
                default: false
            },
            // 是否包裹一圈 dash
            isDash: {
                type: Boolean,
                default: true
            }
        },
        data(){
            return {
                svg: this.toSvg(),
                rotateFastEvent: false,
                rotateRestoreEvent: false,
            }
        },
        computed: {
            classStr: function(){
                return `avatar ${this.isDefaultRotate?'rotate_slow ':''}${this.rotateFastEvent?'rotate_fast ':''}${this.rotateRestoreEvent?'rotate_restore':''}`
            }
        },
        methods: {
            toSvg: function(){
                console.log(`toSvg, hash: ${this.hash}, size: ${this.size}`);
                return jdenticon.toSvg(this.hash, this.size);
            },
            startRotate: function(){
                console.log('avatar, start rotate')
                // 如果默认就是要旋转的，不受 mouseover 时间的影响，因此只对 isDefaultRotate == false 的进行处理
                if(!this.isDefaultRotate){
                    this.rotateFastEvent = true;
                    this.rotateRestoreEvent = false;
                }
            },
            stopRotate: function(){
                console.log('avatar, stop rotate')
                // 如果默认就是要旋转的，不受 mouseleave 时间的影响，因此只对 isDefaultRotate == false 的进行处理
                if(!this.isDefaultRotate){
                    this.rotateRestoreEvent = true;
                    this.rotateFastEvent = false;
                }
            }
        }
    }
</script>

<style>

    /** rotation **/
    .rotate_slow {
        animation: rotation 8s infinite linear;
    }

    .rotate_fast{
        animation: rotation 1.5s infinite linear;
    }

    @keyframes rotation {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(359deg);
        }
    }

    .rotate_restore{
        animation: rotation_restore 0.5s 1 linear;
    }

    @keyframes rotation_restore {
        from {
            transform: rotate(359deg);
        }
        to {
            transform: rotate(0deg);
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/commons/Avatar.vue